module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAPZJREFUOE/FlL0KwjAQgO/aIn0Mf95CKMWX8QFcBAcfQN/DB9DRRaTFxcFVB+PmqGChaNuc2EqNbZo6BMyYXD5yX+4OQ+a49sn0sbeKQbIi5oytczzF7iaUnRf38MHcPlFyaWCwxNbuWgyImLsFoqNlwBCba1YHTYFZUBJxDr7d8Q7ipRT4WsRDBJpYbW+hggrANxb4XlSQA3MKn6sUlIDpYwQFZWAaUKlAChQVmIY5k6ZYoUABzDBIMACEoNrbt4JaoAEwAuAxEd4AMZG/9qPgR2BmlggCQLyrFPwLqDFljZ+SdY6WstFa2Im+1tM4HLSOL90D9glUoRLoxTO5KgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/stitle.png
// module id = Qe9d
// module chunks = 3